import { Grid, Stack } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import './TitleSteps.css';
import successVerde from '../../assets/img/lineaAmarilla/success.svg'
import lineaVerde from '../../assets/img/lineaAmarilla/lineaVerde.svg'




const TitleStepOneDisabled = (props) => {

  return (
    <>
      <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start" className="mX-25">
        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={0}
        >
          <img className="success-img" src={successVerde} alt='' />
          <div className="linea-verde">
            <img src={lineaVerde} alt='' />
            <div className="text-disabled">Queremos saber m&aacute;s de {props.preOrder.petName && props.preOrder.petName}</div>
            <div className="text-asi-disabled">As&iacute; podremos personalizar mejor su seguro.</div>
          </div>
        </Stack>
      </Grid>
    </>
  );
}
const mapStateToProps = state => ({
  preOrder: state.preOrder
});
export default connect(mapStateToProps)(TitleStepOneDisabled)